import script from "./GalleryLandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryLandingPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__